// import { RouteReuseStrategy, DetachedRouteHandle, ActivatedRouteSnapshot } from '@angular/router';

// export class MyReuseStrategy extends DefaultRouteReuseStrategy {
//   shouldReuseRoute(
//     future: ActivatedRouteSnapshot,
//     curr: ActivatedRouteSnapshot,
//     handle: DetachedRouteHandle | null
//   ): boolean {
//     return false;
//   }
// }
import { BaseRouteReuseStrategy, DetachedRouteHandle, RouteReuseStrategy, ActivatedRouteSnapshot } from '@angular/router';

export class MyReuseStrategy extends BaseRouteReuseStrategy implements RouteReuseStrategy {
  shouldReuseRoute(
    future: ActivatedRouteSnapshot,
     curr: ActivatedRouteSnapshot,
     ): boolean {
    return false;
  }

}
// export class MyReuseStrategy implements RouteReuseStrategy {

//     shouldDetach(route: ActivatedRouteSnapshot): boolean {
//       // Implement logic to determine if the route should be detached
//     }
  
//     store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
//       // Implement logic to store the detached route handle
//     }
  
//     shouldAttach(route: ActivatedRouteSnapshot): boolean {
//       // Implement logic to determine if the route should be reattached
//     }
  
//     retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
//       // Implement logic to retrieve the detached route handle
//     }
  
//     shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
//       // Implement logic to determine if the route should be reused
//     }
  
//   }